import { useMemo } from 'react';

import { expValEquals } from '@confluence/feature-experiments';

// Put initialState into a getter
export const useStoreOptions = (initialState: any, isPageSSRd: boolean): any => {
	return useMemo(() => {
		const result: any = {};

		// Include storeOptions if initialState exists and either:
		// - page was SSR'd, OR
		// - local cache is enabled
		if (
			initialState &&
			(isPageSSRd || expValEquals('platform_editor_smartlink_local_cache', 'isEnabled', true))
		) {
			result.storeOptions = {
				initialState,
			};
		}

		return result;
	}, [initialState, isPageSSRd]);
};
